export const keyBy = <T extends string, U extends Record<T, unknown>>(array: U[] = [], key: T) =>
  (array || []).reduce<Record<string | number, U>>((acc, val) => {
    const valKey = val[key];

    if (typeof valKey !== 'string' && typeof valKey !== 'number') {
      return acc;
    }

    return { ...acc, [valKey]: val };
  }, {});
